import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { articles, articleCategories } from "@/mocks/articles";
import PageHeader from "@/components/feature/PageHeader";

export default function ArticleListPage() {
  const [cat, setCat] = useState("全部");

  const list = useMemo(
    () => (cat === "全部" ? articles : articles.filter((a) => a.category === cat)),
    [cat]
  );

  return (
    <>
      <PageHeader
        title="阅读指南与文章专题"
        subtitle="GUIDE &amp; REVIEW"
        desc="从韩国免费漫画资源怎么找，到APP怎么挑、题材怎么选，把韩漫阅读路上的门道一次讲清楚，帮你少走弯路。"
        crumbs={[{ label: "文章专题" }]}
      />

      <section className="mx-auto max-w-7xl px-4 md:px-6 py-8 md:py-12">
        <div className="flex flex-wrap gap-2">
          {articleCategories.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setCat(c)}
              className={`px-3.5 py-1.5 rounded-full text-xs whitespace-nowrap transition-colors ${
                cat === c
                  ? "bg-primary-500 text-background-50 font-bold"
                  : "bg-background-100 text-foreground-700 hover:text-primary-500"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="mt-6 grid md:grid-cols-2 gap-5">
          {list.map((a) => (
            <Link
              key={a.id}
              to={`/article/${a.id}`}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-400/60 transition-colors flex flex-col sm:flex-row"
            >
              <div className="sm:w-2/5 aspect-[16/9] sm:aspect-auto overflow-hidden">
                <img
                  src={a.cover}
                  alt={`${a.title} 韩国免费漫画阅读指南`}
                  title={a.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 p-5 flex flex-col">
                <div className="flex items-center gap-2 text-[11px] text-foreground-600">
                  <span className="px-2 py-0.5 rounded-full bg-primary-100/60 text-primary-500 font-bold">{a.category}</span>
                  <span>{a.date}</span>
                  <span>· {a.readTime}</span>
                </div>
                <h2 className="mt-2.5 font-heading text-base md:text-lg text-foreground-950 leading-snug group-hover:text-primary-500 transition-colors">
                  {a.title}
                </h2>
                <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2">{a.excerpt}</p>
                <span className="mt-auto pt-3 inline-flex items-center gap-1 text-xs text-primary-500">
                  阅读全文 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}